<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/carriers">Carriers</router-link>
                    </li>
                    <template v-if="!carrier.id">
                        <vue-headful :title="'Create Carrier - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Carrier] ' + carrier.carrier_name + ' - AMOS365'" />

                        <li class="breadcrumb-item">
                            <router-link :to="`/carriers/view/${carrier.id}`">{{ carrier.carrier_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ carrier.carrier_name }}</span>
                <span v-else>New Carrier</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.carrier_name, 'text-muted-no': !errors.carrier_name}">
                                    Carrier Name:  <i class="fa fa-sm fa-asterisk text-danger" v-if="!carrier.carrier_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="carrier.carrier_name" :class="{'form-control': true, 'is-invalid': errors.carrier_name}" placeholder="Enter Carrier Name" />

                                    <div class="text-danger mt-2" v-if="errors.carrier_name">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.carrier_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.website, 'text-muted-no': !errors.website}">Website:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="carrier.website" :class="{'form-control': true, 'is-invalid': errors.website}" placeholder="Enter Website" />

                                    <div class="text-danger mt-2" v-if="errors.website">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.website">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="carrier.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Address</div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.address, 'text-muted-no': !errors.address}">Address:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="carrier.address" :class="{'form-control': true, 'is-invalid': errors.address}" placeholder="Enter Address" />

                                    <div class="text-danger mt-2" v-if="errors.address">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.address">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.city, 'text-muted-no': !errors.city}">City:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="carrier.city" :class="{'form-control': true, 'is-invalid': errors.city}" placeholder="Enter City" />

                                    <div class="text-danger mt-2" v-if="errors.city">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.city">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.state_id, 'text-muted-no': !errors.state_id}">State:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="carrier.state_id" :options="stateOptions" size="sm" />

                                    <div class="text-danger mt-2" v-if="errors.state_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.state_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.zip, 'text-muted-no': !errors.zip}">Zip:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="carrier.zip" :class="{'form-control': true, 'is-invalid': errors.zip}" placeholder="Enter Zip" style="max-width: 100px;" />

                                    <div class="text-danger mt-2" v-if="errors.zip">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.zip">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Email ({{ emails.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.emailEditor.addEmail()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <email-editor ref="emailEditor" :emails="emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Phone Numbers ({{ phones.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.phoneEditor.addPhone()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <phone-editor ref="phoneEditor" :phones="phones" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Address ({{ addresses.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.addressEditor.addAddress()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <address-editor ref="addressEditor" :addresses="addresses" :states="states" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveCarrier()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveCarrier()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                carrier: {},
                errors: {},
                states: [],
                addresses: [],
                emails: [],
                phones: [],
            }
        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getCarrier(){
                //Send it
                this.$http.get('/carriers/edit' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set the carrier
                        this.carrier = response.data.carrier;
                        this.states = response.data.states;
                        this.addresses = response.data.addresses;
                        this.emails = response.data.emails;
                        this.phones = response.data.phones;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveCarrier(){
                //Helpers
                this.saving = true;

                //Reset ERror
                this.errors = {};
                this.$refs.emailEditor.setErrors({});
                this.$refs.phoneEditor.setErrors({});
                this.$refs.addressEditor.setErrors({});

                //Append Stuff to the Payload
                this.carrier.emails = this.$refs.emailEditor.getEmails();
                this.carrier.phones = this.$refs.phoneEditor.getPhones();
                this.carrier.addresses = this.$refs.addressEditor.getAddresses();

                //Send it
                this.$http
                .post('carriers/save', this.carrier)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Carrier ' + (this.carrier.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/carriers/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the errors for the component editors
                        this.$refs.emailEditor.setErrors(this.errors);
                        this.$refs.phoneEditor.setErrors(this.errors);
                        this.$refs.addressEditor.setErrors(this.errors);

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Carrier');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

        },

        mounted() {
            //get the carrier?
            this.getCarrier();
        }
    }
</script>
